import { get } from '@si/utils';
import { useQuery } from '@tanstack/react-query';
import { z } from 'zod';

import { projectTeamMemberSchema } from '../types/projectTeam';
import { queryKeys } from './queryKeys';

const responseSchema = z.object({
  projectTeamMembers: z.array(projectTeamMemberSchema),
});

interface Params {
  projectId: string;
  noRetry?: boolean;
}

export function useProjectTeam({ projectId, noRetry = false }: Params) {
  const url = `/projects/${projectId}/team`;

  const { data, error, isLoading } = useQuery({
    queryKey: queryKeys.getProjectUsers(projectId),
    queryFn: () => get({ url, schema: responseSchema }),
    enabled: !!projectId,
    retry: !noRetry,
  });

  return {
    projectTeamMembers: data?.projectTeamMembers || [],
    error,
    isLoading,
  };
}
